import { analytics } from '@/services/analytics/segment'
import { CommunityFeed, Post } from '@/types'

function contributePostOptionEvent(
  type: string,
  prompt?: Pick<Post, 'description' | 'id' | 'title'> & { source?: string }
) {
  let eventName = 'contribute_text'

  if (type === 'image') {
    eventName = 'contribute_image'
  } else if (type === 'video') {
    eventName = 'contribute_video'
  }

  const payload: Record<string, any> = {
    source: prompt ? 'prompt' : 'feed'
  }

  if (prompt) {
    payload.prompt_name = prompt.title
    payload.prompt_id = prompt.id
  }

  analytics.track(eventName, payload)
}

function feedActionEvent(eventName: string, item: CommunityFeed, extraActions?: Record<string, any>) {
  const payload: Record<string, any> = {
    feed_item_id: item.id,
    type: item.type
  }

  if (extraActions?.liked !== undefined) {
    payload.liked = extraActions.liked
  }

  if (extraActions?.doubleTap !== undefined) {
    payload.double_tap = extraActions.doubleTap
  }

  analytics.track(eventName, payload)
}

function contributePostEvent(extraData?: {
  type: string
  post: Post
  prompt?: Pick<Post, 'title' | 'id'>
  response?: Record<string, any>
  source?: string
}) {
  const eventName = extraData?.type === 'photo' ? 'contribute_image_post' : 'contribute_video_post'

  const fileType = eventName.includes('image') ? 'image' : 'video'

  const payload: Record<string, any> = {
    feed_item_id: extraData?.post.feed_item,
    [`${fileType}_id`]: extraData?.post.id
  }

  if (extraData?.prompt) {
    payload.prompt_name = extraData?.prompt.title
    payload.prompt_id = extraData?.prompt.id
  }

  if (extraData?.response) {
    payload.response = extraData.response
  }

  if (extraData?.source) {
    payload.source = extraData.source
  }

  analytics.track(eventName, payload)
}

function contributeTextPostEvent(
  eventName: string,
  extraData?: {
    prompt?: Pick<Post, 'title' | 'id'> | null
    values?: Record<string, any>
    source?: string
  }
) {
  const payload: Record<string, any> = {}

  if (extraData?.prompt) {
    ;((payload.prompt_name = extraData.prompt.title), (payload.prompt_id = extraData.prompt.id))
  }

  if (extraData?.values) {
    payload.title = extraData.values.title
    payload.description = extraData.values.description
  }

  if (extraData?.source) {
    payload.source = extraData.source
  }

  analytics.track(eventName, payload)
}

function contributeCancelFileEvent(extraData: { prompt: Pick<Post, 'title' | 'id'> | null; type: string }) {
  const { prompt, type } = extraData

  const eventName = type === 'photo' ? 'contribute_image_cancel' : 'contribute_video_cancel'

  const fileType = eventName.includes('image') ? 'image' : 'video'

  const payload: Record<string, any> = {
    source: prompt ? 'prompt' : 'feed'
  }

  if (fileType === 'image') {
    payload.response = prompt ? 'prompt' : 'feed'
  }

  if (prompt) {
    payload.prompt_name = prompt.title
  }

  analytics.track(eventName, payload)
}

export const communityAnalytics = {
  contributeCancelFileEvent,
  contributeTextPostEvent,
  contributePostEvent,
  contributePostOptionEvent,
  feedActionEvent
}
